import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { ModalProps } from './types/persona-modal.types';
import { useTranslation } from 'react-i18next';



export const Modal = ({ isOpen, onClose, result }: ModalProps) => {
    const { t } = useTranslation();
	if (!isOpen || !result) return null;

	return (
		<div id="result-modal-overlay" className="fixed inset-0 z-50 flex items-start justify-center bg-black/20 overflow-auto">
			<div id="result-modal-card" className="bg-white rounded-xl mt-40 w-[884px] p-8 relative flex flex-col gap-4 shadow-lg">
				<div id="result-modal-header" className="flex items-center justify-between w-full">
					<div id="result-modal-title" className="text-2xl text-[#2e2e2e] font-bold">
						{t('survey.atCategory')} {result.catNumber} {result.title}
					</div>
					<IconButton
						onClick={onClose}
						size="small"
					>
						<CloseIcon />
					</IconButton>
				</div>

				<div id="result-modal-body" className="flex flex-row gap-10 mt-4">
					<div id="result-modal-image" className="relative w-[285px] h-[256px] flex-shrink-0 pt-4">
						<img
							src={result.image}
							alt={result.subtitle}
							className="w-full h-full object-contain"
						/>
					</div>

					<div id="result-modal-content" className="flex flex-col gap-4 w-[525px]">
						<div className="flex flex-col gap-1 items-start">
							<div id="result-modal-subtitle" className="text-[#2a807b] font-bold text-[22px] leading-[24px]">{result.subtitle}</div>
							{result.tagline && (
								<div id="result-modal-tagline" className="text-[#2a807b] font-semibold text-[18px] leading-[24px]">
									{result.tagline}
								</div>
							)}
						</div>

						{result.infoBlocks.map((block) => (
							<div
								key={block.title}
								className="flex gap-3 items-start"
                                id={`info-block-${block.title}`}
							>
								<div
                                    id={`icon-${block.title}`}
									className="w-10 h-10 min-w-[40px] flex-shrink-0 flex items-center justify-center
                  bg-gradient-to-b from-[#05859C] to-[#51A790] rounded-full
                  p-2 shadow-[0px_0.89px_1.77px_rgba(10,13,18,0.06),0px_0.89px_2.66px_rgba(10,13,18,0.1)]"
								>
									{block.iconHtml ? (
										<div
                                            id={`icon-html-${block.title}`}
											className="flex items-center justify-center"
											dangerouslySetInnerHTML={{ __html: block.iconHtml }}
										/>
									) : block.icon ? (
										<img
											src={block.icon}
											alt={block.title}
											className="w-5 h-5"
                                            id={`icon-img-${block.title}`}
                                            />
									) : null}
								</div>

								<div id={`info-block-content-${block.title}`} className="flex flex-col gap-1 items-start flex-1">
									<div id={`info-block-title-${block.title}`} className="text-[#2e2e2e] font-semibold text-[18px] leading-[24px] text-left">
										{block.title}
									</div>
									<div id={`info-block-content-text-${block.title}`} className="text-[#363636] font-normal text-[16px] leading-[24px] text-left whitespace-pre-wrap break-words">
										{block.content}
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};
